import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export const ContentTab = () => {
  const [pages, setPages] = useState([]);
  const [activeSlug, setActiveSlug] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [saving, setSaving] = useState(false);

  const loadPages = () => api.get("/admin/pages").then((r) => { setPages(r.data); setActiveSlug((cur) => cur || r.data[0]?.slug || null); });
  const loadFaqs = () => api.get("/admin/faqs").then((r) => setFaqs(r.data));
  useEffect(() => { loadPages(); loadFaqs(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  const active = pages.find((p) => p.slug === activeSlug);
  const setActiveField = (k, v) => setPages(pages.map((p) => (p.slug === activeSlug ? { ...p, [k]: v } : p)));

  const savePage = async () => {
    if (!active) return;
    setSaving(true);
    try { await api.put(`/admin/pages/${active.slug}`, { title: active.title, content: active.content }); toast.success("Page saved"); }
    catch { toast.error("Save failed"); }
    setSaving(false);
  };

  const addFaq = async () => { await api.post("/admin/faqs", { question: "New question", answer: "Answer" }); loadFaqs(); };
  const saveFaq = async (f) => {
    try { await api.put(`/admin/faqs/${f.id}`, { question: f.question, answer: f.answer, is_active: f.is_active }); toast.success("FAQ saved"); }
    catch { toast.error("Save failed"); }
  };
  const delFaq = async (id) => { await api.delete(`/admin/faqs/${id}`); loadFaqs(); toast.success("FAQ deleted"); };
  const setFaqField = (id, k, v) => setFaqs(faqs.map((f) => (f.id === id ? { ...f, [k]: v } : f)));

  return (
    <div className="space-y-6" data-testid="content-tab">
      <div className="font-heading text-2xl text-brand-navy">Content</div>

      <div className="bg-white border border-slate-200 rounded-2xl p-5">
        <div className="font-heading text-lg text-brand-navy mb-3">Pages</div>
        <div className="flex flex-wrap gap-2 mb-4">
          {pages.map((p) => (
            <button key={p.slug} onClick={() => setActiveSlug(p.slug)} data-testid={`content-page-tab-${p.slug}`}
              className={`px-3 h-9 rounded-full text-sm font-bold ${activeSlug === p.slug ? "bg-brand-navy text-white" : "bg-slate-100 text-slate-600"}`}>{p.title}</button>
          ))}
        </div>
        {active && (
          <div className="space-y-3">
            <label className="block">
              <span className="text-xs font-bold text-slate-600 uppercase tracking-wider">Title</span>
              <input value={active.title || ""} onChange={(e) => setActiveField("title", e.target.value)} data-testid="content-page-title"
                className="mt-1 w-full h-10 rounded-lg border border-slate-200 px-3" />
            </label>
            <label className="block">
              <span className="text-xs font-bold text-slate-600 uppercase tracking-wider">Content</span>
              <textarea rows={10} value={active.content || ""} onChange={(e) => setActiveField("content", e.target.value)} data-testid="content-page-body"
                className="mt-1 w-full rounded-lg border border-slate-200 p-3" />
            </label>
            <button onClick={savePage} disabled={saving} data-testid="content-page-save"
              className="bg-brand-navy text-white rounded-full px-6 h-11 font-bold disabled:opacity-60">Save page</button>
          </div>
        )}
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-5">
        <div className="flex items-center justify-between mb-3">
          <div className="font-heading text-lg text-brand-navy">FAQ</div>
          <button onClick={addFaq} data-testid="content-faq-add" className="inline-flex items-center gap-1 bg-brand-red text-white rounded-full h-9 px-4 font-bold text-sm"><Plus className="h-4 w-4" /> Add FAQ</button>
        </div>
        <div className="space-y-3">
          {faqs.map((f) => (
            <div key={f.id} className="border border-slate-200 rounded-xl p-3 space-y-2" data-testid={`content-faq-${f.id}`}>
              <input value={f.question} onChange={(e) => setFaqField(f.id, "question", e.target.value)} data-testid={`content-faq-q-${f.id}`}
                className="w-full h-10 rounded-lg border border-slate-200 px-3 font-bold" />
              <textarea rows={2} value={f.answer} onChange={(e) => setFaqField(f.id, "answer", e.target.value)} data-testid={`content-faq-a-${f.id}`}
                className="w-full rounded-lg border border-slate-200 p-2 text-sm" />
              <div className="flex items-center gap-3 flex-wrap">
                <label className="inline-flex items-center gap-2 text-sm"><input type="checkbox" checked={!!f.is_active} onChange={(e) => setFaqField(f.id, "is_active", e.target.checked)} /> Active</label>
                <button onClick={() => saveFaq(f)} data-testid={`content-faq-save-${f.id}`} className="bg-brand-navy text-white rounded-full px-4 h-9 font-bold text-sm">Save</button>
                <button onClick={() => delFaq(f.id)} data-testid={`content-faq-del-${f.id}`} className="text-brand-red inline-flex items-center gap-1 text-sm font-bold"><Trash2 className="h-4 w-4" /> Delete</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
